import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgencyService {

  configService: ConfigService;

  constructor(public http: HttpClient) {
    this.configService = new ConfigService();
  }

  createAgency(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token,
      //'Content-Type': 'application/json'
      //'Content-Type' :'multipart/form-data;  boundary=----WebKitFormBoundaryXXXXXXXXX'
    });
    return this.http.post(this.configService.serverIp.concat('/createAgency'), data, { headers });
  }

  listServices() {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/listServices'), { headers });
  }

  getPaymentTypesAgency(agency_id) {
    const token = localStorage.getItem('currentUser');
    const params = new HttpParams().set('agency', agency_id);
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/getPaymentTypesAgency'), { headers, params});
  }

  reportAgencies(data) {

    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/reportAgencies'), data, { headers });

  }

  /**
   * Servicio encargado de obtener el reporte de totales de  las agencias
   */
  reportAgenciesMaster(data) {

    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/reportAgenciesMaster'), data, { headers });

  }

  exportPdfAgenciesReport(data) {

    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/exportPdfAgenciesReport'), data, { headers });

  }



  exportExcelAgenciesReport(data) {

    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/exportExcelAgenciesReport'), data, { headers });

  }



  updateAgency(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/updateAgency'), data, { headers });
  }

  updateContactAgency(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/updateContactUserOfAgency'), data, { headers });
  }

  getAllAgencies(): Observable<any> {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/getAllAgencies'), { headers });
  }

  getAgencyById(id) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    const params = new HttpParams().set('agency_id', id);
    return this.http.get(this.configService.serverIp.concat('/getAgencyById'), { headers, params });
  }


  getServicesByAgency(id) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    const params = new HttpParams().set('agency_id', id);
    return this.http.get(this.configService.serverIp.concat('/getServicesOfAgency'), { headers, params });
  }

  getServicesByAgencyAuto() {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/getServicesOfAgency'), { headers });
  }

  editServiceByAgency(service) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/editServiceOfAgency'), service, { headers });
  }

  //
  assignServiceToAgency(agency_id, services) {
    const data = {
      'agency_id': agency_id,
      'services': services
    };
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/assignServiceToAgency'), data, { headers });
  }

  listClientsAgency() {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/listClientsOfAgency'), { headers });
  }

  getFrequentsClientSenders(data) {

    const params = new HttpParams().set('user_id', data);
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/getFrequentShippingsFromUser'), { headers, params });

  }

  deleteFrequentShippingsFromUser(data: any) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/deleteFrequentShippingsFromUser'), data, { headers });
  }

  getReportsAgency(data) {

    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/generateReportAgency'), data, { headers });

  }

  getPdfReportsAgency(data) {

    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/generatePDFReportAgency'), data, { headers });

  }


  getPdfReportsLoker(data) {

    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/generatePDFReportLocker'), data, { headers });

  }


  getExcelReportsAgency(data) {

    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/generateExcelReportAgency'), data, { headers });

  }

  getServicesAgency(id) {
    const params = new HttpParams().set('id_agency', id);
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/getServicesOfAgency'), { headers, params });
  }

  getAgencyPermissions(agencyId) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    let params = new HttpParams();
    if (agencyId) {
      params = params.append('agencyId', agencyId);
    }
    return this.http.get(this.configService.serverIp.concat('/getAgencyPermissions'), { headers, params });
  }

  getServicesOfAgencyByCountry(country_id, agencyId) {
    //const params = new HttpParams().set('country_id', country_id);
    let params = new HttpParams();
    params = params.append('country_id', country_id);
    if (agencyId) {
      params = params.append('agency_id', agencyId);
    }

    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/getServicesOfAgencyByCountry'), { headers, params });

  }

  getCarriersLocalForAgency() {

    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/getCarriersLocalForAgency'), { headers });

  }


  getReferredInfo() {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/getReferredInfo'), { headers });
  }

  searchDeliveryReport(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/searchDeliveryReport'), data, { headers });
  }

  guidesOfDashboard(skip) {

    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    const params = new HttpParams().set('skip', skip);
    return this.http.get(this.configService.serverIp.concat('/guidesOfDashboard'), { headers, params });

  }

  noveltiesGuidesOfDashboard() {

    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/noveltiesGuidesOfDashboard'), { headers });

  }

  /**
   * Metodo encargado de conectarse al servicio del backend para generar un excel
   * con el reporte de agencias master
   */
  exportExcelAgenciesMasterReport(data) {

    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/exportExcelAgenciesMasterReport'), data, { headers });

  }

  dailyReport(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/dailyReport'), data, { headers });

  }

  reportImport(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/reportImport'), data, { headers });

  }

  reportJournal(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/reportJournal'), data, { headers });

  }
}
